import React from "react";

const Disclaimer = () => {
  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        maxWidth: "800px",
        margin: "auto",
      }}
    >
      <h1 style={{ textAlign: "center", color: "#007BFF", fontSize: 38 }}>
        Disclaimer
      </h1>
      <p>
        The information provided on the <strong>Blue Washer</strong> website is
        for general informational purposes only. While we strive to ensure
        accuracy and reliability, we make no representations or warranties of
        any kind, express or implied, regarding the completeness, accuracy, or
        reliability of any information, services, or related graphics contained
        on the website.
      </p>

      <h2 className="mt-4 font-bold">Service Availability</h2>
      <p>
        Our services are subject to availability and may vary depending on
        location, weather conditions, or other unforeseen circumstances. Blue
        Washer reserves the right to modify, suspend, or discontinue any service
        without prior notice.
      </p>

      <h2 className="mt-4 font-bold">Third-Party Links</h2>
      <p>
        Our website may contain links to third-party websites for your
        convenience. We do not endorse or assume responsibility for the content,
        policies, or practices of these external sites. Accessing third-party
        links is at your own risk.
      </p>

      <h2 className="mt-4 font-bold">Liability</h2>
      <p>
        Blue Washer shall not be held liable for any loss or damage arising
        directly or indirectly from the use of our website, services, or
        inability to access the same. This includes, but is not limited to,
        technical issues, inaccuracies, or data loss.
      </p>
      <br />
      <p>
        Please remove all valuable items from your vehicle before the car wash.
        We are not responsible for any lost, stolen, or misplaced belongings
        left inside the car. By using our service, you acknowledge that we do
        not assume liability for personal items left unattended in your vehicle.
      </p>
      <h2 className="mt-4 font-bold">Changes to Disclaimer</h2>
      <p>
        We reserve the right to update or modify this Disclaimer at any time
        without prior notice. Users are encouraged to review this page
        periodically to stay informed about any changes.
      </p>

      <h2 className="mt-4 font-bold">Contact Us</h2>
      <p>
        For questions or concerns regarding this Disclaimer, please contact us
        at
        <a href="mailto:support@bluewasher.com" style={{ color: "#007BFF" }}>
          {" "}
          support@bluewasher.com
        </a>
        .
      </p>

      <p style={{ textAlign: "center", marginTop: "20px" }}>
        <em>Last updated: 14th Feb 2025</em>
      </p>
    </div>
  );
};

export default Disclaimer;
